module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("71oV7"))).then(() => parcelRequire('cvs7o'));